var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('h2',{staticClass:"h2-header"},[_vm._v("Welcome")]),_c('h5',{staticClass:"h5-header"},[_vm._v("Sign up done")]),_c('div',{staticClass:"mt-4"},[_c(_vm.upsaleDeal,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }